import React, { Component } from "react";
import fire from '../fire';
import { Grid, Item } from "semantic-ui-react";
import TaskItem from "../SiteLayout/TaskItem";

class LessonList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lessons:[]
    };
  }

  componentDidMount() {
  
    const lessonsRef = fire.database().ref('lessons');

    lessonsRef.once('value', snapshot => {
      let lessons = snapshot.val();
      let newState = [];

      for (let item in lessons) {
        newState.push({
          id: item,
          title: lessons[item].title,
          number: lessons[item].number,
          description: lessons[item].description,
          youtubeId: lessons[item].youtubeId,
          soundCloudId: lessons[item].soundCloudId,
          assignment: lessons[item].assignment
        });
      }

      newState.sort(function(a, b){return a.number-b.number});

      this.setState({
        lessons: newState
      });
    });
  }

  render(){
    return(
      <Grid columns={1}>
        <Grid.Column>
          <Item.Group divided>
            {
              this.state.lessons.map((item, index) =>
                <TaskItem key={item.id} Index={index} Number={item.number} Header={item.title} Description={item.description} YoutubeId={item.youtubeId} Assignment={item.assignment} SoundCloudId={item.soundCloudId} />
              )
            }
          </Item.Group>
          
        </Grid.Column>
      </Grid>
    );
  }
}
export default LessonList;